import { setFetchUserStatus, setUser } from "actions/user";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute() {
    yield put(setFetchUserStatus("loading"));
    try {
        const response = yield post("/me", {});
        if (response.data !== null) {
            yield put(setUser(response.data));
            yield put(setFetchUserStatus("none"));
        } else {
            yield put(setFetchUserStatus("error"));
        }
    } catch (e) {
        yield put(setFetchUserStatus("error"));
        yield handleNetworkError(e);
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.user.IFetchUser", execute);
}
